import angular from 'angular'
import './notifications.service'

angular
  .module('admin.notifications', ['admin.notifications.service'])
  .controller('NotificationsCtrl', NotificationsCtrl)

/** @ngInject */
function NotificationsCtrl(
  $scope,
  $state,
  $stateParams,
  $timeout,
  NotificationsService,
  NotificationHistoryService,
  UsersService,
) {
  var vm = this
  vm.works = false
  vm.isChannel = false
  vm.isNumber = true
  vm.waitChannel = true
  vm.waitSet = true
  vm.channels = []
  vm.bundles = []
  vm.sets = []
  vm.isOpen = false

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  if ($stateParams.userId !== '') {
    UsersService.get($stateParams.userId).then(success)

    function success(result) {
      vm.model = {}
      vm.model = result.results
      $('#target').val('users')
      $('.collectible-target-channel').hide()
      $('.collectible-target-users').hide()
      $('.collectible-target-users').show()
      $('#users').val(vm.model.username)
    }
  }

  var watch = $scope.$watch('vm.channel', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    NotificationsService.listSets(newVal).then(function (response) {
      vm.sets = response.results
      vm.bundles = []
      vm.waitSet = true
      vm.waitChannel = false
    })
  })

  var watch1 = $scope.$watch('vm.set', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    NotificationsService.listBundles(newVal).then(function (response) {
      vm.bundles = []
      var bundles = response.results
      for (var i = 0; i < bundles.length; i++) {
        if (bundles[i].st === 1) {
          var b = bundles[i]
          b.t = b.id + ' - ' + b.t
          vm.bundles.push(b)
        }
      }
      vm.waitSet = false
    })
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
  })

  NotificationsService.list().then(
    function (response) {
      vm.channels = response.result
      $.each(response.result, function (index, item) {
        $('#form-group-channels').append(
          '<div class="col-sm-4"><div class="checkbox"><label><input type="checkbox" value="' +
            item.id +
            '">' +
            item.st +
            '</label></div>',
        )
      })
    },
    function () {
      swal('Problem loading channels!', '', 'error')
    },
  )

  $('#target').on('change', function () {
    $('.collectible-target-channel').hide()
    $('.collectible-target-users').hide()

    if (this.value == 'users') {
      $('.collectible-target-users').show()
    } else if (this.value == 'channels') {
      $('.collectible-target-channel').show()
    } else {
    }
  })

  $('#link').on('change', function () {
    if (this.value === 'bs') {
      vm.channel = null
      vm.set = null
      vm.bundle = null
      vm.isChannel = true
      vm.isNumber = false
    } else {
      vm.isChannel = false
      vm.isNumber = true
      $('#number').val('')
    }

    $scope.$apply()
  })

  $('#btnSubmit').on('click', function () {
    vm.works = true
    $('#btnSubmit').hide()
    var target = $('#target').val()
    var message = $('#message').val().trim()
    var group = $('#group').val()
    var k = $('#link').val()
    var s
    var combo = {}

    if (message.length < 15) {
      swal('Message must contain at least 15 characters.', '', 'error')
      vm.works = false
      $('#btnSubmit').show()
      return
    }

    if (k === undefined || k === '') {
      swal('Need select deep link.', '', 'error')
      vm.works = false
      $('#btnSubmit').show()
      return
    }

    var link = $('#link').val()
    if (link === 'bs') {
      if (vm.channel === undefined || vm.channel === null) {
        swal('You need to select a channel!', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }
      if (vm.set === undefined || vm.set === null) {
        swal('You need to select a set!', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }
      if (vm.bundle === undefined || vm.bundle === null) {
        swal('You need to select a bundle!', '', 'error')
        vm.works = false
        $('#btnSubmit').show()
        return
      }
      combo = { k: 'bs', channel: vm.channel, set: vm.set, bundle: vm.bundle }
      s = vm.bundle.toString()
      k = 'b'
    } else {
      combo = undefined
      s = $('#number').val()
    }

    if (s === undefined || s === '') {
      swal('You need to select a number or combo box.', '', 'error')
      vm.works = false
      $('#btnSubmit').show()
      return
    }

    if (message !== '') {
      if (k !== '' && s !== '') {
        var data = { target: target, message: message, k: k, s: s }
      } else {
        var data = { target: target, message: message }
      }

      if (group !== '') {
        data['group'] = group
      }

      var users = []
      var channels = ''
      if (target === 'users') {
        if ($('#users').val() === '') {
          swal('You need to select a Specific Users!', '', 'error')
          vm.works = false
          $('#btnSubmit').show()
          return
        }
        var users = $('#users').val().replace(/\s/g, '').split(',')
        data['users'] = users
      } else if (target === 'channels') {
        $('#form-group-channels input:checked').each(function () {
          users.push($(this).val())
          channels += $(this).parent().text() + ','
        })
        data['users'] = users

        if (channels === '') {
          swal('Choose a Channel.', '', 'error')
          vm.works = false
          $('#btnSubmit').show()
          return
        }
      }

      $('#loaderBlock').show()

      var deepName
      switch (link) {
        case 'u':
          deepName = 'users/'
          break
        case 'b':
          deepName = 'bundles/'
          break
        case 'bs':
          deepName = 'bundlessplunge/'
          break
        case 's':
          deepName = 'sets/'
          break
        case 'ch':
          deepName = 'channels/'
          break
        case 'c':
          deepName = 'coinstores/'
          break
        case 'p':
          deepName = 'posts/'
          break
        case 'fb':
          deepName = 'freebundles/'
          break
      }

      data.combo = combo
      data.channels = channels

      var model = {
        txt: data.message,
        to: JSON.stringify(data),
        dl: deepName + data.s,
      }

      var date1
      if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
        if (isDate(vm.data1)) {
          model.st = 1
          var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
          model['ts-p'] = date1
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      }

      if (vm.data1 === null) {
        model['ts-p'] = null
      }

      model.n = 1

      NotificationHistoryService.save(model).then(function () {
        var msg = 'Create with Success!'
        $('#alertResult').show()
        if (msg !== 'Sorry the notification may have failed') {
          $('#resultMsg').text(msg)
        }

        $('#btnSubmit').show()
        $('#loaderBlock').hide()
        vm.works = false

        $timeout(function () {
          $state.go('admin.notification_history')
        }, 200)
      })
    } else {
      vm.works = false
      $('#btnSubmit').show()
    }
  })
}
